<template>
  <PCard class="content-cta-form-skeleton">
    <SHeadingSkeleton v-if="heading" size="3" width="12.5rem" />
    <div class="content-cta-form-skeleton__form">
      <SInputSkeleton class="content-cta-form-skeleton__input" label />
      <SButtonSkeleton class="content-cta-form-skeleton__button" width="" />
    </div>
    <STextSkeleton
      class="content-cta-form-skeleton__trust"
      font-size="sm"
      width="16rem"
    />
  </PCard>
</template>

<script setup lang="ts">
import {
  PCard,
  SButtonSkeleton,
  SHeadingSkeleton,
  SInputSkeleton,
  STextSkeleton,
} from "@solvari/components";

defineProps<{ heading?: boolean }>();
</script>

<style lang="postcss">
.content-cta-form-skeleton {
  &__form {
    @apply flex flex-col;

    @screen 600 {
      @apply flex-row gap-3.5;
    }
  }

  &__input {
    @screen 600 {
      @apply flex-1;
    }
  }

  &__button {
    @apply mt-2 w-full;

    @screen 600 {
      @apply mt-auto w-48;
    }
  }

  &__trust {
    @apply mx-auto mt-4 border-t border-slate-200 pt-4;

    .s-text-skeleton > * {
      @apply !mb-0;
    }
  }
}
</style>
